module.exports = __webpack_public_path__ + "static/logo-2@2x-386be0823e1490033c6a146d8f2af991.png";